var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.type == 'combination_equipment8')?_c('combination-equipment-descriptor',{attrs:{"recipe-id":_vm.data.r,"sub-recipe-id":_vm.data.i}}):_vm._e(),(_vm.type == 'combination_consumable8')?_c('combination-consumable-descriptor',{attrs:{"recipe-id":_vm.data.r,"sub-recipe-id":_vm.data.s}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }